import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import PublicLayout from '../layouts/PublicLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'
import LandingPage from '../views/public/LandingPage.vue'
import LoginPage from '../views/public/LoginPage.vue'
import RegisterPage from '../views/public/RegisterPage.vue'
import ForgotPasswordPage from '../views/public/ForgotPasswordPage.vue'
import ResetPasswordPage from '../views/public/ResetPasswordPage.vue'
import DashboardPage from '../views/app/DashboardPage.vue'
import DocumentsPage from '../views/app/DocumentsPage.vue'
import DocumentGeneratorPage from '../views/app/DocumentGeneratorPage.vue'
import DocumentValidatorPage from '../views/app/DocumentValidatorPage.vue'
import JudicialMetadataPage from '../views/app/JudicialMetadataPage.vue'
import RequestsPage from '../views/app/RequestsPage.vue'
import PoliciesPage from '../views/app/PoliciesPage.vue'
import EvidencePage from '../views/app/EvidencePage.vue'
import AuditPage from '../views/app/AuditPage.vue'
import BillingPage from '../views/app/BillingPage.vue'
import EmployeesPage from '../views/app/EmployeesPage.vue'
import MyAccountPage from '../views/app/MyAccountPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: PublicLayout,
    children: [
      {
        path: '',
        name: 'landing',
        component: LandingPage,
        meta: {
          title: 'ComplyOps | Gestão documental jurídica com evidências',
          description: 'Crie, valide e gerencie documentos jurídicos com rastreabilidade, evidências e controle operacional.'
        }
      },
      {
        path: 'login',
        name: 'login',
        component: LoginPage,
        meta: {
          title: 'Entrar | ComplyOps',
          description: 'Acesse sua operação documental no ComplyOps.'
        }
      },
      {
        path: 'criar-conta',
        name: 'register',
        component: RegisterPage,
        meta: {
          title: 'Criar conta | ComplyOps',
          description: 'Comece a organizar, gerar e validar documentos jurídicos com o ComplyOps.'
        }
      },
      {
        path: 'recuperar-senha',
        name: 'forgot-password',
        component: ForgotPasswordPage,
        meta: {
          title: 'Recuperar senha | ComplyOps',
          description: 'Recupere o acesso à sua conta ComplyOps.'
        }
      },
      {
        path: 'redefinir-senha',
        name: 'reset-password',
        component: ResetPasswordPage,
        meta: {
          title: 'Redefinir senha | ComplyOps',
          description: 'Defina uma nova senha de acesso à sua conta ComplyOps.'
        }
      }
    ]
  },
  {
    path: '/app',
    component: AppLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: '/app/dashboard' },
      { path: 'dashboard', name: 'dashboard', component: DashboardPage },
      { path: 'uso-seguro', redirect: '/app/validar-documento' },
      { path: 'documentos', name: 'documents', component: DocumentsPage },
      { path: 'gerar-documento', name: 'document-generator', component: DocumentGeneratorPage },
      { path: 'validar-documento', name: 'document-validator', component: DocumentValidatorPage },
      { path: 'metadados-judiciais', name: 'judicial-metadata', component: JudicialMetadataPage },
      { path: 'inventario', name: 'tools', redirect: '/app/politicas' },
      { path: 'solicitacoes', name: 'requests', component: RequestsPage },
      { path: 'politicas', name: 'policies', component: PoliciesPage },
      { path: 'evidencias', name: 'evidences', component: EvidencePage },
      { path: 'funcionarios', name: 'employees', component: EmployeesPage },
      { path: 'audit', name: 'audit', component: AuditPage },
      { path: 'minha-conta', name: 'my-account', component: MyAccountPage },
      { path: 'billing', name: 'billing', component: BillingPage }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior: (to) => {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 70 }
      }
    }

    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.requiresAuth) && !store.getters['auth/isAuthenticated']) {
    return next({ name: 'login' })
  }

  next()
})

router.afterEach((to) => {
  const nearestMeta = [...to.matched].reverse().find(route => route.meta && route.meta.title)
  const fallbackTitle = to.path.startsWith('/app') ? 'ComplyOps | Plataforma' : 'ComplyOps | Gestão documental jurídica com evidências'
  const fallbackDescription = 'ComplyOps ajuda equipes jurídicas a criar, validar, gerenciar e auditar documentos com trilha de evidências.'
  const title = nearestMeta ? nearestMeta.meta.title : fallbackTitle
  const description = nearestMeta && nearestMeta.meta.description ? nearestMeta.meta.description : fallbackDescription

  document.title = title
  updateMeta('description', description)
  updateMeta('og:title', title, 'property')
  updateMeta('og:description', description, 'property')
  updateMeta('twitter:title', title)
  updateMeta('twitter:description', description)
})

function updateMeta (name, content, attribute = 'name') {
  let element = document.head.querySelector(`meta[${attribute}="${name}"]`)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, name)
    document.head.appendChild(element)
  }
  element.setAttribute('content', content)
}

export default router
